import { html } from 'rune-ts';

export const kakao = html`<svg width="1em" height="1em" fill="none" viewBox="0 0 29 28">
  <g clip-path="url(#kakao_a)">
    <g clip-path="url(#kakao_b)">
      <path
        fill="#141414"
        fill-rule="evenodd"
        d="M14.5 4.2C8.7 4.2 4 7.832 4 12.311c0 2.786 1.818 5.242 4.587 6.702L7.422 23.27c-.103.376.327.676.657.458l5.107-3.37c.43.041.868.065 1.314.065 5.799 0 10.5-3.631 10.5-8.11C25 7.831 20.299 4.2 14.5 4.2Z"
        clip-rule="evenodd"
      />
    </g>
  </g>
  <defs>
    <clipPath id="kakao_a">
      <path fill="#fff" d="M.5 0h28v28H.5z" />
    </clipPath>
    <clipPath id="kakao_b">
      <path fill="#fff" d="M4 3.5h21v21H4z" />
    </clipPath>
  </defs>
</svg> `;
export const kakao_logo = html`<svg width="1em" height="1em" fill="none" viewBox="0 0 22 22">
  <g clip-path="url(#kakao_logo_a)">
    <g clip-path="url(#kakao_logo_b)">
      <path
        fill="#000"
        fill-rule="evenodd"
        d="M11 3.65c-4.35 0-7.875 2.724-7.875 6.084 0 2.089 1.364 3.93 3.44 5.026l-.874 3.192c-.077.282.246.507.493.343l3.83-2.527c.323.03.652.049.986.049 4.35 0 7.875-2.724 7.875-6.083 0-3.36-3.526-6.084-7.875-6.084Z"
        clip-rule="evenodd"
      />
    </g>
  </g>
  <defs>
    <clipPath id="kakao_logo_a">
      <path fill="#fff" d="M.5.5h21v21H.5z" />
    </clipPath>
    <clipPath id="kakao_logo_b">
      <path fill="#fff" d="M3.125 3.125h15.75v15.75H3.125z" />
    </clipPath>
  </defs>
</svg> `;

export const ciety_kakao_logo = html`<svg width="1em" height="1em" fill="none" viewBox="0 0 22 22">
  <g clip-path="url(#kakao_logo_a)">
    <g clip-path="url(#kakao_logo_b)">
      <path
        fill="#FEE500"
        fill-rule="evenodd"
        d="M11 3.65c-4.35 0-7.875 2.724-7.875 6.084 0 2.089 1.364 3.93 3.44 5.026l-.874 3.192c-.077.282.246.507.493.343l3.83-2.527c.323.03.652.049.986.049 4.35 0 7.875-2.724 7.875-6.083 0-3.36-3.526-6.084-7.875-6.084Z"
        clip-rule="evenodd"
      />
    </g>
  </g>
  <defs>
    <clipPath id="kakao_logo_a">
      <path fill="#fff" d="M.5.5h21v21H.5z" />
    </clipPath>
    <clipPath id="kakao_logo_b">
      <path fill="#fff" d="M3.125 3.125h15.75v15.75H3.125z" />
    </clipPath>
  </defs>
</svg> `;

export const kakao_inactive = html`<svg width="1em" height="1em" fill="none" viewBox="0 0 29 28">
  <g clip-path="url(#kakao_a)">
    <g clip-path="url(#kakao_b)">
      <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M14.5 4.2C8.7 4.2 4 7.832 4 12.311c0 2.786 1.818 5.242 4.587 6.702L7.422 23.27c-.103.376.327.676.657.458l5.107-3.37c.43.041.868.065 1.314.065 5.799 0 10.5-3.631 10.5-8.11C25 7.831 20.299 4.2 14.5 4.2Z"
        clip-rule="evenodd"
      />
    </g>
  </g>
  <defs>
    <clipPath id="kakao_a">
      <path fill="#fff" d="M.5 0h28v28H.5z" />
    </clipPath>
    <clipPath id="kakao_b">
      <path fill="#fff" d="M4 3.5h21v21H4z" />
    </clipPath>
  </defs>
</svg> `;

export const naver = html`<svg width="1em" height="1em" viewBox="0 0 29 28" fill="none">
  <path
    d="M17.8247 14.6575L10.9049 4.66699H5.16797V23.3337H11.1771V13.3439L18.0977 23.3337H23.8346V4.66699H17.8247V14.6575Z"
    fill="white"
  />
</svg>`;
export const naver_logo = html`<svg width="1em" height="1em" fill="none" viewBox="0 0 22 22">
  <path fill="#03C75A" d="M13.493 11.493 8.303 4H4v14h4.507v-7.492L13.697 18H18V4h-4.507v7.493Z" />
</svg> `;

export const naver_inactive = html`<svg width="1em" height="1em" viewBox="0 0 28 28" fill="none">
  <path
    d="M17.3247 14.6575L10.4049 4.66699H4.66797V23.3337H10.6771V13.3439L17.5977 23.3337H23.3346V4.66699H17.3247V14.6575Z"
    fill="currentColor"
  />
</svg>`;

export const google = html`<svg width="1em" height="1em" viewBox="0 0 29 28" fill="none">
  <g clip-path="url(#google_icon)">
    <path
      d="M24.7958 11.9436H23.95V11.9H14.5V16.1H20.4341C19.5684 18.5449 17.2421 20.3 14.5 20.3C11.0208 20.3 8.2 17.4792 8.2 14C8.2 10.5208 11.0208 7.7 14.5 7.7C16.106 7.7 17.567 8.30585 18.6795 9.29547L21.6495 6.32555C19.7741 4.57782 17.2657 3.5 14.5 3.5C8.70137 3.5 4 8.20137 4 14C4 19.7986 8.70137 24.5 14.5 24.5C20.2986 24.5 25 19.7986 25 14C25 13.296 24.9275 12.6088 24.7958 11.9436Z"
      fill="#FFC107"
    />
    <path
      d="M5.21065 9.11277L8.66043 11.6427C9.59387 9.3317 11.8545 7.7 14.5 7.7C16.106 7.7 17.567 8.30585 18.6795 9.29547L21.6495 6.32555C19.7741 4.57782 17.2657 3.5 14.5 3.5C10.4669 3.5 6.9694 5.77692 5.21065 9.11277Z"
      fill="#FF3D00"
    />
    <path
      d="M14.5 24.5C17.2121 24.5 19.6765 23.4621 21.5397 21.7742L18.29 19.0243C17.2004 19.8529 15.8689 20.3011 14.5 20.3C11.7689 20.3 9.45003 18.5586 8.57643 16.1284L5.15238 18.7665C6.89013 22.1669 10.4192 24.5 14.5 24.5Z"
      fill="#4CAF50"
    />
    <path
      d="M24.7958 11.9436H23.95V11.9H14.5V16.1H20.4341C20.02 17.2636 19.274 18.2804 18.2884 19.0248L18.29 19.0243L21.5397 21.7742C21.3098 21.9832 25 19.25 25 14C25 13.296 24.9275 12.6088 24.7958 11.9436Z"
      fill="#1976D2"
    />
  </g>
  <defs>
    <clipPath id="google_icon">
      <rect width="1em" height="1em" fill="white" transform="translate(0.5)" />
    </clipPath>
  </defs>
</svg>`;
export const google_logo = html`<svg width="1em" height="1em" fill="none" viewBox="0 0 22 22">
  <g clip-path="url(#google_logo_a)">
    <path
      fill="#FFC107"
      d="M18.722 9.458h-.635v-.033H11v3.15h4.45A4.723 4.723 0 0 1 6.276 11 4.725 4.725 0 0 1 11 6.275a4.7 4.7 0 0 1 3.135 1.197l2.227-2.228A7.839 7.839 0 0 0 11 3.125a7.875 7.875 0 1 0 7.722 6.333Z"
    />
    <path
      fill="#FF3D00"
      d="M4.033 7.335 6.62 9.232A4.723 4.723 0 0 1 11 6.275a4.7 4.7 0 0 1 3.135 1.197l2.227-2.228A7.839 7.839 0 0 0 11 3.125a7.87 7.87 0 0 0-6.967 4.21Z"
    />
    <path
      fill="#4CAF50"
      d="M11 18.875a7.838 7.838 0 0 0 5.28-2.044l-2.438-2.063a4.69 4.69 0 0 1-2.842.957 4.723 4.723 0 0 1-4.443-3.129L3.99 14.575a7.869 7.869 0 0 0 7.011 4.3Z"
    />
    <path
      fill="#1976D2"
      d="M18.722 9.458h-.635v-.033H11v3.15h4.45a4.741 4.741 0 0 1-1.609 2.194h.002l2.437 2.062c-.173.156 2.595-1.893 2.595-5.831 0-.528-.054-1.043-.153-1.542Z"
    />
  </g>
  <defs>
    <clipPath id="google_logo_a">
      <path fill="#fff" d="M.5.5h21v21H.5z" />
    </clipPath>
  </defs>
</svg> `;

export const google_inactive = html`<svg width="1em" height="1em" viewBox="0 0 28 28" fill="none">
  <g clip-path="url(#google_icon_inactive)">
    <path
      d="M24.2958 11.9436H23.45V11.9H14V16.1H19.9341C19.0684 18.5449 16.7421 20.3 14 20.3C10.5208 20.3 7.7 17.4792 7.7 14C7.7 10.5208 10.5208 7.7 14 7.7C15.606 7.7 17.067 8.30585 18.1795 9.29547L21.1495 6.32555C19.2741 4.57782 16.7657 3.5 14 3.5C8.20137 3.5 3.5 8.20137 3.5 14C3.5 19.7986 8.20137 24.5 14 24.5C19.7986 24.5 24.5 19.7986 24.5 14C24.5 13.296 24.4276 12.6088 24.2958 11.9436Z"
      fill="currentColor"
    />
    <path
      d="M4.71065 9.11277L8.16043 11.6427C9.09387 9.3317 11.3545 7.7 14 7.7C15.606 7.7 17.067 8.30585 18.1795 9.29547L21.1495 6.32555C19.2741 4.57782 16.7657 3.5 14 3.5C9.96695 3.5 6.4694 5.77692 4.71065 9.11277Z"
      fill="currentColor"
    />
    <path
      d="M14 24.5C16.7121 24.5 19.1765 23.4621 21.0397 21.7742L17.79 19.0243C16.7004 19.8529 15.3689 20.3011 14 20.3C11.2689 20.3 8.95003 18.5586 8.07643 16.1284L4.65238 18.7665C6.39013 22.1669 9.91917 24.5 14 24.5Z"
      fill="currentColor"
    />
    <path
      d="M24.2958 11.9436H23.45V11.9H14V16.1H19.9341C19.52 17.2636 18.774 18.2804 17.7884 19.0248L17.79 19.0243L21.0397 21.7742C20.8098 21.9831 24.5 19.25 24.5 14C24.5 13.296 24.4276 12.6088 24.2958 11.9436Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="google_icon_inactive">
      <rect width="1em" height="1em" fill="white" />
    </clipPath>
  </defs>
</svg>`;

export const apple = html`<svg width="1em" height="1em" viewBox="0 0 29 28" fill="none">
  <g clip-path="url(#apple_icon)">
    <path
      d="M23.3947 9.12212C23.2594 9.22713 20.8698 10.5736 20.8698 13.5676C20.8698 17.0306 23.9105 18.2557 24.0015 18.286C23.9875 18.3607 23.5184 19.9639 22.3983 21.5974C21.3995 23.0348 20.3564 24.47 18.7696 24.47C17.1828 24.47 16.7744 23.5482 14.9426 23.5482C13.1574 23.5482 12.5227 24.5003 11.0712 24.5003C9.6197 24.5003 8.60693 23.1702 7.44248 21.5367C6.09368 19.6185 5.00391 16.6385 5.00391 13.8103C5.00391 9.2738 7.95353 6.8679 10.8565 6.8679C12.399 6.8679 13.6848 7.88066 14.6532 7.88066C15.575 7.88066 17.0124 6.80722 18.7673 6.80722C19.4324 6.80722 21.8219 6.8679 23.3947 9.12212ZM17.9342 4.8867C18.6599 4.02561 19.1733 2.83083 19.1733 1.63604C19.1733 1.47036 19.1593 1.30234 19.129 1.16699C17.9482 1.21133 16.5434 1.9534 15.6963 2.93584C15.0312 3.69191 14.4105 4.8867 14.4105 6.09782C14.4105 6.27984 14.4409 6.46185 14.4549 6.52019C14.5295 6.5342 14.6509 6.55053 14.7722 6.55053C15.8317 6.55053 17.1641 5.84113 17.9342 4.8867Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="apple_icon">
      <rect width="1em" height="1em" fill="white" transform="translate(0.5)" />
    </clipPath>
  </defs>
</svg>`;
export const apple_logo = html`<svg width="1em" height="1em" fill="none" viewBox="0 0 21 22">
  <g clip-path="url(#apple_logo_a)">
    <path
      fill="#000"
      d="M17.17 7.341c-.101.08-1.894 1.089-1.894 3.334 0 2.598 2.28 3.516 2.35 3.54-.011.055-.363 1.258-1.203 2.483-.75 1.078-1.532 2.154-2.722 2.154s-1.496-.691-2.87-.691c-1.339 0-1.815.714-2.904.714-1.088 0-1.848-.998-2.721-2.223-1.012-1.438-1.83-3.673-1.83-5.795.001-3.402 2.213-5.206 4.39-5.206 1.157 0 2.122.76 2.848.76.691 0 1.77-.806 3.085-.806.5 0 2.292.046 3.471 1.736Zm-4.095-3.176c.544-.646.929-1.542.929-2.438 0-.124-.01-.25-.033-.352-.886.033-1.94.59-2.575 1.327-.498.567-.964 1.463-.964 2.371 0 .137.023.273.033.317.056.01.147.023.238.023.795 0 1.794-.532 2.372-1.248Z"
    />
  </g>
  <defs>
    <clipPath id="apple_logo_a">
      <path fill="#fff" d="M0 .5h21v21H0z" />
    </clipPath>
  </defs>
</svg> `;

export const ciety_apple_logo = html`<svg width="1em" height="1em" fill="none" viewBox="0 0 21 22">
  <g clip-path="url(#apple_logo_a)">
    <path
      fill="#FFFFFF"
      d="M17.17 7.341c-.101.08-1.894 1.089-1.894 3.334 0 2.598 2.28 3.516 2.35 3.54-.011.055-.363 1.258-1.203 2.483-.75 1.078-1.532 2.154-2.722 2.154s-1.496-.691-2.87-.691c-1.339 0-1.815.714-2.904.714-1.088 0-1.848-.998-2.721-2.223-1.012-1.438-1.83-3.673-1.83-5.795.001-3.402 2.213-5.206 4.39-5.206 1.157 0 2.122.76 2.848.76.691 0 1.77-.806 3.085-.806.5 0 2.292.046 3.471 1.736Zm-4.095-3.176c.544-.646.929-1.542.929-2.438 0-.124-.01-.25-.033-.352-.886.033-1.94.59-2.575 1.327-.498.567-.964 1.463-.964 2.371 0 .137.023.273.033.317.056.01.147.023.238.023.795 0 1.794-.532 2.372-1.248Z"
    />
  </g>
  <defs>
    <clipPath id="apple_logo_a">
      <path fill="#fff" d="M0 .5h21v21H0z" />
    </clipPath>
  </defs>
</svg> `;

export const apple_inactive = html` <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none">
  <g clip-path="url(#apple_icon_inactive)">
    <path
      d="M22.8947 9.12212C22.7594 9.22713 20.3698 10.5736 20.3698 13.5676C20.3698 17.0306 23.4105 18.2557 23.5015 18.286C23.4875 18.3607 23.0184 19.9639 21.8983 21.5974C20.8995 23.0348 19.8564 24.47 18.2696 24.47C16.6828 24.47 16.2744 23.5482 14.4426 23.5482C12.6574 23.5482 12.0227 24.5003 10.5712 24.5003C9.1197 24.5003 8.10693 23.1702 6.94248 21.5367C5.59368 19.6185 4.50391 16.6385 4.50391 13.8103C4.50391 9.2738 7.45353 6.8679 10.3565 6.8679C11.899 6.8679 13.1848 7.88066 14.1532 7.88066C15.075 7.88066 16.5124 6.80722 18.2673 6.80722C18.9324 6.80722 21.3219 6.8679 22.8947 9.12212ZM17.4342 4.8867C18.1599 4.02561 18.6733 2.83083 18.6733 1.63604C18.6733 1.47036 18.6593 1.30234 18.629 1.16699C17.4482 1.21133 16.0434 1.9534 15.1963 2.93584C14.5312 3.69191 13.9105 4.8867 13.9105 6.09782C13.9105 6.27984 13.9409 6.46185 13.9549 6.52019C14.0295 6.5342 14.1509 6.55053 14.2722 6.55053C15.3317 6.55053 16.6641 5.84113 17.4342 4.8867Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="apple_icon_inactive">
      <rect width="1em" height="1em" fill="white" />
    </clipPath>
  </defs>
</svg>`;

export const facebook = html`<svg width="1em" height="1em" viewBox="0 0 29 28" fill="none">
  <g clip-path="url(#facebook_icon)">
    <path
      d="M17.8834 6.83667C16.5884 6.83667 16.2151 7.40833 16.2151 8.68V10.78H19.6684L19.3184 14.175H16.2034V24.4883H12.0501V14.175H9.26172V10.78H12.0501V8.73833C12.0501 5.30833 13.4384 3.5 17.3001 3.5C18.1401 3.5 19.1201 3.55833 19.7151 3.64V6.83667"
      fill="white"
    />
  </g>
  <defs>
    <clipPath id="facebook_icon">
      <rect width="1em" height="1em" fill="white" transform="translate(0.5)" />
    </clipPath>
  </defs>
</svg>`;
export const facebook_logo = html`<svg width="1em" height="1em" fill="none" viewBox="0 0 21 22">
  <g clip-path="url(#facebook_logo_a)">
    <path
      fill="#0866FF"
      d="M13.037 5.628c-.972 0-1.252.428-1.252 1.382v1.575h2.59l-.262 2.546h-2.336v7.735H8.662v-7.735H6.57V8.585h2.092V7.054c0-2.573 1.04-3.929 3.937-3.929.63 0 1.365.044 1.811.105v2.398"
    />
  </g>
  <defs>
    <clipPath id="facebook_logo_a">
      <path fill="#fff" d="M0 .5h21v21H0z" />
    </clipPath>
  </defs>
</svg> `;

export const facebook_inactive = html` <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none">
  <g clip-path="url(#facebook_icon_inactive)">
    <path
      d="M17.3834 6.83667C16.0884 6.83667 15.7151 7.40833 15.7151 8.68V10.78H19.1684L18.8184 14.175H15.7034V24.4883H11.5501V14.175H8.76172V10.78H11.5501V8.73833C11.5501 5.30833 12.9384 3.5 16.8001 3.5C17.6401 3.5 18.6201 3.55833 19.2151 3.64V6.83667"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="facebook_icon_inactive">
      <rect width="1em" height="1em" fill="white" />
    </clipPath>
  </defs>
</svg>`;
